/*
 * @Author: JettyHuang
 * @LastEditors: JettyHuang
 * @Description:
 * @Date: 2021-03-03 18:15:48
 * @LastEditTime: 2021-04-28 15:56:18
 * @FilePath: /yft-b2c-web-h5/src/pages/Shop/Member/Wallet/MyWallet/MyWalletMod.js
 */
import { observable, action, flow } from 'mobx';
import Util from 'utils';
import Config from 'config/Config';
import Stores from 'config/Stores';
import Serv from './CisternWalletServ';

class CisternWalletMod {
  @observable walletBalance = 0; // 钱包余额

  @observable walletBonus = 0; // 分红积分

  @observable hasBonus = false; //是否有分红积分

  @observable cisternBalance = 0; // 蓄水池余额

  @observable chargeAmountSum = 0; // 钱包累计充值金额

  @observable latestTransaction = null; // 最新一项明细

  @observable totalCoupon = 0; // 优惠券数量

  @observable exchangeCouponCount = 0; // 产品兑换券数量

  @observable listData = {
    data: [],
    isLoading: false,
    hasPullToRefresh: true,
    pageNum: 1,
    pages: 1
  };

  @action
  changeState(obj) {
    Object.keys(obj).forEach((key) => {
      this[key] = obj[key];
    });
  }

  /**
   * 获取钱包信息
   */
  getWalletInfo = flow(function* () {
    try {
      const { data } = yield Serv.getWalletInfo();
      if (data && data.length > 0) {
        for (const item of data) {
          const { accountType, usefulBalance, chargeAmountSum } = item;
          switch (accountType) {
            case 'NOMAL':
              this.walletBalance = usefulBalance || 0;
              this.chargeAmountSum = chargeAmountSum || 0;
              break;
            case 'CISTERN':
              this.cisternBalance = usefulBalance || 0;
              break;
            case 'BONUS':
              this.walletBonus = usefulBalance || 0;
              this.hasBonus = true;
              break;
            default:
              break;
          }
        }
      }
    } catch (error) {}
  });

  /**
   * 获取最新一项明细
   */
  getTransactionList = flow(function* (pageNum = 1) {
    const { listData } = this;

    this.listData.isLoading = true;
    try {
      const { data } = yield Serv.getTransactionList(pageNum);
      this.listData.isLoading = false;
      if (pageNum !== 1) {
        const arr = listData.data || [];
        this.listData.data = arr.concat(data.list || []);
      } else {
        this.listData.data = data.list || [];
      }
      // 重置页数等信息
      this.listData.pageNum = data.pageNum;
      this.listData.pages = data.pages;
    } catch (error) {
      this.listData.isLoading = false;
    }
  });

  @action
  clearData() {
    this.walletBalance = 0;
    this.cisternBalance = 0;
    this.latestTransaction = null;
  }

  /**
   * 获取各种优惠券数量
   */
  getCouponCount = flow(function* () {
    const { data } = yield Serv.getCouponCount({
      userId: Stores.AppMod.userInfo.id
    });
    this.totalCoupon = 0;
    data.forEach((item) => {
      this.totalCoupon += item.count;
      if (item.couponType == 5) {
        this.exchangeCouponCount = item.count;
      }
    });
  });
}

const cisternWalletMod = new CisternWalletMod();
export default cisternWalletMod;



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Wallet/CisternWallet/CisternWalletMod.js